import { Tooltip, Typography, Stack } from '@cast/design-system';

import { WorkloadBaseRunningInNode } from 'features/cluster/nodes/types';

type Props = {
  workload: WorkloadBaseRunningInNode;
  children: React.ReactElement;
};

export const WorkloadIssuesTooltip = ({ workload, children }: Props) => {
  if (!workload.issues.length) {
    return children;
  }

  return (
    <Tooltip
      testId="workload-problem-tooltip"
      title={
        <Stack spacing={8}>
          <Typography variant="L10R">Workload issues:</Typography>
          <Stack
            component="ul"
            spacing={8}
            sx={{
              pl: 16,
              '& li': { typography: 'P12R' },
            }}
          >
            {workload.issues.map((issue) => (
              <li key={issue.description}>{issue.description}</li>
            ))}
          </Stack>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  );
};
